import {type BetterSystemStyleObject, Box} from '@primer/react'
import type {ReactNode} from 'react'

import styles from './ContentWrapper.module.css'

export function ContentWrapper({children, sx}: {children: ReactNode; sx?: BetterSystemStyleObject}) {
  return (
    <Box
      sx={{
        ...sx,
      }}
      className={styles.contentContainer}
    >
      {children}
    </Box>
  )
}

try{ ContentWrapper.displayName ||= 'ContentWrapper' } catch {}